<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import PikuTradeComponent from "@/component/project/PikuTradeComponent.vue";

@Component({
  components: {PikuTradeComponent, NavBar}
})
export default class PikuTradeView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <PikuTradeComponent/>
  </div>
</template>

<style scoped>
.view-container {
  margin-left: 80px;
  height: 100vh;
  background-color: var(--background-color);
  overflow-y: auto;
}
</style>